"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
require("./index.scss");
const clsx_1 = __importDefault(require("clsx"));
const table_cell_sanitizer_1 = require("@App/helpers/table-cell-sanitizer");
const CellInput = ({ name, defaultValue, readOnly, tooltipId, min, max, type, onValueChanged }) => {
    const { control, setValue } = (0, react_hook_form_1.useFormContext)();
    const typeIsANumber = type === 'number';
    const sanitizedValue = (0, table_cell_sanitizer_1.tableCellSanitizer)(defaultValue, typeIsANumber ? '' : '--');
    const isNumber = (numberString) => !isNaN(parseFloat(numberString)) && !isNaN(parseInt(numberString, 10));
    const onChange = (field, e) => {
        {
            const displayValue = e.target.value;
            let value = displayValue;
            if (isNumber(value)) {
                const parsedNumber = Number.parseFloat(e.target.value);
                if (min !== undefined && max && parsedNumber >= min && parsedNumber <= max) {
                    value = parsedNumber;
                }
                else {
                    return;
                }
            }
            field.onChange(displayValue);
            onValueChanged && onValueChanged(value);
        }
    };
    // setValue needs to be used to set the default value of the input field, using defaultValue on the Controller will not work as expected.
    // https://stackoverflow.com/questions/64306943/defaultvalues-of-react-hook-form-is-not-setting-the-values-to-the-input-fields-i
    (0, react_1.useEffect)(() => {
        setValue(name, sanitizedValue);
    }, [sanitizedValue, setValue]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, shouldUnregister: true, defaultValue: sanitizedValue, render: ({ field, fieldState }) => (react_1.default.createElement("div", { className: 'cell-input' },
                react_1.default.createElement("div", { className: 'input-container' },
                    react_1.default.createElement("input", Object.assign({ className: (0, clsx_1.default)(fieldState.error && 'error', typeIsANumber && 'number-input'), "data-tooltip-id": fieldState.error && `${tooltipId}`, readOnly: readOnly, type: 'text', min: min, max: max }, field, { onChange: (e) => onChange(field, e) })),
                    !readOnly && react_1.default.createElement("span", { className: 'percentage-sign' }, "%")),
                fieldState.error && (react_1.default.createElement("span", { className: 'error-message' }, fieldState.error.message)))) })));
};
exports.default = CellInput;
